import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { Bonuses } from './components/Bonuses';
import { OfferSection } from './components/OfferSection';
import { Comparison } from './components/Comparison';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Load the Meta Pixel only once the page is idle so it never competes
    // with the hero rendering.
    const start = () => initMetaPixel();
    const scope = window as unknown as {
      requestIdleCallback?: (cb: () => void, opts?: {
        timeout: number;
      }) => number;
      cancelIdleCallback?: (id: number) => void;
    };
    const useIdle = typeof scope.requestIdleCallback === 'function';
    const id = useIdle ? (scope.requestIdleCallback as (cb: () => void, opts?: {
      timeout: number;
    }) => number)(start, {
      timeout: 3000
    }) : window.setTimeout(start, 1800);
    return () => {
      if (useIdle && typeof scope.cancelIdleCallback === 'function') {
        scope.cancelIdleCallback(id);
      } else {
        window.clearTimeout(id);
      }
    };
  }, []);
  return <div className="w-full min-h-full bg-bone font-sans text-court-950 antialiased" data-id="element-0" data-mp="33n6y54p9hv5d">
      <Hero data-id="element-1" data-mp="38l03xwmnkn54" />
      <main data-id="element-2" data-mp="38k6w0sbyjrle">
        <Problems data-id="element-3" data-mp="38nup5qdhqbzl" />
        <SystemOverview data-id="element-4" data-mp="3dkuufz2inapn" />
        <Bonuses data-id="element-5" data-mp="3dle4ktlxcut4" />
        <OfferSection data-id="element-6" data-mp="3dlw9sfqkejd6" />
        <div className="defer-paint" data-id="element-7" data-mp="3dm6064fiusje">
          <Comparison data-id="element-8" data-mp="nvsub5qlapwh" />
          <Testimonials data-id="element-9" data-mp="nwc582htoe10" />
          <Guarantee data-id="element-10" data-mp="nv0wrpdfmi3k" />
          <Faq data-id="element-11" data-mp="nxwxflgnzkvp" />
          <FinalCta data-id="element-12" data-mp="sunfgec14qjr" />
        </div>
      </main>
      <Footer data-id="element-13" data-mp="stc6m03q8sls" />
      <PurchasePopup data-id="element-14" data-mp="sssr0q1jugax" />
    </div>;
}